import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';
import { AuthProvider } from '@/features/auth';
import { sessionStore } from '@/shared/api';
import { syncColorScheme } from '@/shared/lib/color-scheme';
import { AppErrorBoundary } from '@/shared/ui/feedback';
import { Toaster } from '@/shared/ui/primitives/sonner';
import { createAppQueryClient } from './query-client';
import { createAppRouter } from './router';

/** Raiz do SPA: providers (auth com renovação silenciosa, Query), toast, ErrorBoundary e router. */
export function App(): ReactNode {
  const [queryClient] = useState(createAppQueryClient);
  const [router] = useState(() => createAppRouter(queryClient));

  useEffect(() => syncColorScheme(), []);

  useEffect(
    () =>
      sessionStore.subscribe((state, previous) => {
        if (state.generation !== previous.generation) {
          void queryClient.cancelQueries();
          queryClient.clear();
        }
      }),
    [queryClient],
  );

  return (
    <AppErrorBoundary>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster richColors closeButton />
        </QueryClientProvider>
      </AuthProvider>
    </AppErrorBoundary>
  );
}
